import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import { Search, PenTool, Code2, Rocket, type LucideIcon } from "lucide-react";

const ICONS: LucideIcon[] = [Search, PenTool, Code2, Rocket];

export function ProcessSteps() {
  const { t } = useTranslation();
  const steps = t("process.steps", { returnObjects: true }) as { title: string; description: string }[];

  return (
    <div className="relative grid grid-cols-2 md:grid-cols-4 gap-x-4 gap-y-8 sm:gap-6">
      <div className="hidden md:block absolute top-8 left-[12.5%] right-[12.5%] h-px process-line" />

      {steps.map((step, index) => {
        const Icon = ICONS[index] ?? Search;
        return (
          <motion.div
            key={step.title}
            className="relative flex flex-col items-center text-center"
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: index * 0.12 }}
          >
            <div className="relative z-10 w-12 h-12 sm:w-16 sm:h-16 rounded-2xl flex items-center justify-center mb-3 sm:mb-6 border border-border/60 bg-card backdrop-blur-xl shadow-lg">
              <Icon className="w-5 h-5 sm:w-7 sm:h-7 text-primary" />
              <span className="absolute -top-1.5 -right-1.5 sm:-top-2 sm:-right-2 w-5 h-5 sm:w-6 sm:h-6 rounded-full bg-primary text-primary-foreground text-[10px] sm:text-xs font-bold flex items-center justify-center">
                {index + 1}
              </span>
            </div>
            <h3 className="font-semibold text-sm sm:text-lg mb-1 sm:mb-2">{step.title}</h3>
            <p className="text-xs sm:text-sm text-muted-foreground leading-relaxed max-w-[180px] sm:max-w-[240px]">{step.description}</p>
          </motion.div>
        );
      })}
    </div>
  );
}
